// extracted by mini-css-extract-plugin
export default {"container":"_39pQOvDF","icon":"_3n2DUh2i","bodyContainer":"_2amBh8KC","footer":"al0uazNB","button":"CPa15jPT"};